import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./MainScreen.css";
import Main from "../Main/Main";
// import "../../../src/App.css";
import UpcomingEvents from "../UpcomingEvents/UpcomingEvents";
import Footer from "../Footer/Footer";
import Header from "../header/Header";
import ScrollCasino from "../ScrollCasino/ScrollCasino";
import ScrollGames from "../ScrollGames/ScrollGames";
import News from "../News/news";
// import Helper from "../../helper";
import SideMenu from "../SideMenu/SideMenu";
import OpenBets from "../OpenBets/OpenBets";
import Othercasino from "../OtherCasino/Othercasino";
import Indiancardgames from "../IndianCardGames/Indiancardgames";
import Appconfig from "../../config/config";
import axios from "axios";
import { FaWhatsapp } from "react-icons/fa";
import CasinoImageGrid from "../CasinoImageGrid/CasinoImageGrid";
import DesktopLiveMatches from "../DesktopLiveMatches/DesktopLiveMatches";
import WelcomeBannerModal from "../WelcomeBannerModal/WelcomeBannerModal";
import RightPlayGames from "../RightPlayGames/RightPlayGames";
import TopGameGrid from "../TopGameGrid/TopGameGrid";
import DashboardGames from "../DashboardGames/DashboardGames";
import DesktopCasino from "../DesktopCasino/DesktopCasino";
import NewLaunchGames from "../NewLaunchGames/NewLaunchGames";
import MobileBottomNav from "../MobileBottomNav/MobileBottomNav";
import MobileCasinoProviders from "../MobileCasinoProviders/MobileCasinoProviders";
import MobileExchangeGames from "../MobileExchangeGames/MobileExchangeGames";

const MainScreen = () => {
  // const userInfo = Helper();
  const location = useLocation();

  const sportFromUrl = Number(
    new URLSearchParams(location.search).get("sport"),
  );

  const selectedSportId = [4, 1, 2].includes(sportFromUrl)
    ? sportFromUrl
    : null;

  const isDesktopCasino =
    new URLSearchParams(location.search).get("view") === "casino";

  // const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
  const [eventType, setEventType] = useState(undefined);
  const [showMenu, setShowMenu] = useState(false);
  // const [events, setEvents] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [whatsappNum, setWhatsAppNumber] = useState("");

  const upcomingEventsRef = useRef(null); // 👈 Create ref

  // Sync eventType from navigation state
  useEffect(() => {
    if (location.state && location.state.eventType !== undefined) {
      setEventType(location.state.eventType);
    }
  }, [location.state]);

  // 👇 Scroll to UpcomingEvents when eventType changes
  useEffect(() => {
    if (eventType && upcomingEventsRef.current) {
      const yOffset = isMobile ? 140 : 100;
      const y =
        upcomingEventsRef.current.getBoundingClientRect().top +
        window.pageYOffset -
        yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }, [eventType, isMobile]);

  // Resize handler
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile) {
      document.body.style.overflow = "";
      return;
    }

    document.body.style.overflow = showMenu ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [showMenu, isMobile]);

  // Scroll to Indian Card Games when navigated via pathname
  useEffect(() => {
    if (location.pathname === "/indiancardgames") {
      const el = document.getElementById("indiancardgames");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  // const handleToggleMenu = () => setShowMenu((prev) => !prev);

  const openSideMenu = () => {
    setShowMenu(true);
  };

  const closeSideMenu = () => {
    setShowMenu(false);
  };

  const handleToggleMenu = () => {
    setShowMenu((previousValue) => !previousValue);
  };

  useEffect(() => {
    getWhatsAppNumber();
  }, []);

  const getWhatsAppNumber = () => {
    var data = JSON.stringify({
      site_code: Appconfig.sitecodes,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}numbers/getNumberBySiteCode`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          if (response.data.result) {
            setWhatsAppNumber(response.data?.resultData?.mob_num);
          }
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        // postErrorToslack(error.message);
        console.log(error);
      });
  };

  return (
    <div>
      <WelcomeBannerModal />

      <Header
        showMenu={showMenu}
        openSideMenu={openSideMenu}
        closeSideMenu={closeSideMenu}
        handleToggleMenu={handleToggleMenu}
        isMobile={isMobile}
        whatsappNum={whatsappNum}
        setEventType={setEventType}
      />

      <div className="main-content-wrapper">
        {isMobile ? (
          <>
            <div>
              <ScrollGames
                setEventType={setEventType}
                eventType={eventType}
                isMobile={isMobile}
              />

              <TopGameGrid />

              <NewLaunchGames />
            </div>
            <div className="reference-mobile-page">
              <News />

              <div ref={upcomingEventsRef}>
                <UpcomingEvents
                  eventType={eventType}
                  showDashboardInplay={true}
                />
              </div>

              <MobileCasinoProviders />

              <MobileExchangeGames />

              {/* <CasinoImageGrid /> */}

              {/* <ScrollCasino /> */}

              {/* <div id="indiancardgames">
                <Indiancardgames />
              </div> */}

              {/* <Footer /> */}
            </div>

            <MobileBottomNav />

            {showMenu && (
              <>
                <div className="sidemenu-overlay" onClick={closeSideMenu} />

                <aside
                  className="sidemenu-mobile open"
                  onClick={(event) => event.stopPropagation()}
                >
                  <SideMenu
                    handleToggleMenu={closeSideMenu}
                    closeSideMenu={closeSideMenu}
                    isMobile={isMobile}
                    whatsappNum={whatsappNum}
                    setEventType={setEventType}
                  />
                </aside>
              </>
            )}
          </>
        ) : (
          <div className="mainscreen-container">
            <aside className="desktop-left-sidebar">
              <SideMenu
                handleToggleMenu={closeSideMenu}
                closeSideMenu={closeSideMenu}
                isMobile={false}
                whatsappNum={whatsappNum}
                setEventType={setEventType}
              />
            </aside>

            <main className="desktop-main-content">
              {isDesktopCasino ? (
                <DesktopCasino />
              ) : (
                <>
                  <TopGameGrid />

                  <UpcomingEvents
                    key={`upcoming-events-${location.search}`}
                    eventType={selectedSportId ?? eventType}
                    showDashboardInplay={selectedSportId === null}
                    tableTitle={selectedSportId ? "EXCHANGE" : "INPLAY"}
                  />
                </>
              )}
            </main>

            <aside className="desktop-right-sidebar">
              <RightPlayGames />
            </aside>

            {!isDesktopCasino && (
              <div className="desktop-dashboard-games-row">
                <DashboardGames />
              </div>
            )}

            {/* <CasinoImageGrid /> */}
          </div>
        )}
      </div>

      {!isMobile && <Footer />}

      {/* WhatsApp Floating Icon */}
      {whatsappNum && (
        <a
          href={`https://wa.me/${whatsappNum}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            position: "fixed",
            bottom: "24px",
            right: "24px",
            zIndex: 1000,
            background: "#25D366",
            borderRadius: "50%",
            width: "56px",
            height: "56px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          }}
          title="Chat on WhatsApp"
        >
          <FaWhatsapp size={32} color="#fff" />
        </a>
      )}
    </div>
  );
};

export default MainScreen;
